/**
 * Funções auxiliares para os serviços de Acompanhamento.
 */

/**
 * Cria função de log condicionada à flag `window.__acompDebug`.
 * Preserva compatibilidade com suporte em produção via DevTools.
 *
 * @param {string} modulo
 * @returns {(...args: any[]) => void}
 */
export function criarLogger(modulo) {
  return (...args) => {
    if (typeof window !== "undefined" && window.__acompDebug) {
      // eslint-disable-next-line no-console
      console.log(`[Acompanhamento/${modulo}][DEBUG]`, ...args);
    }
  };
}

/**
 * Extrai lista de itens a partir de diferentes formatos de resposta da API
 * (array simples, { data: [] }, { autorizacoes: [] }, { items: [] }, { results: [] }
 * ou objeto único com id/tce_id/tca_id).
 *
 * @param {any} data
 * @returns {Array<object>}
 */
export function extrairListaDeResposta(data) {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.data)) return data.data;
  if (Array.isArray(data.autorizacoes)) return data.autorizacoes;
  if (Array.isArray(data.items)) return data.items;
  if (Array.isArray(data.results)) return data.results;

  if (
    data &&
    typeof data === "object" &&
    (data.id ||
      data.tce_id ||
      data.tca_id ||
      data.tca_empregador_id ||
      data.autorizacao_id)
  ) {
    return [data];
  }

  return [];
}

/**
 * Normaliza os metadados de programa (tipo_programa, total_etapas e _origem)
 * para um payload de autorização.
 *
 * @param {object|null} payload
 * @param {number} programaEfetivo (0 = TCE, 1 = TCA, 2 = TCA Empregador)
 * @returns {object|null}
 */
export function aplicarMetadadosPrograma(payload, programaEfetivo) {
  if (!payload || typeof payload !== "object") return payload;

  if (programaEfetivo === 1) {
    const temEstudante = Boolean(
      payload.nome_aprendiz ||
      payload.cpf_aprendiz ||
      payload.estudante_nome ||
      payload.estudante_cpf ||
      payload.nome_estudante ||
      payload.cpf_estudante ||
      /aprendiz|estudante/i.test(payload.status || "") ||
      /aprendiz|estudante/i.test(payload.status_label || "")
    );
    return {
      ...payload,
      tipo_programa: 1,
      total_etapas: temEstudante ? 5 : 4,
      _origem: "tca",
    };
  }

  if (programaEfetivo === 0) {
    return {
      ...payload,
      tipo_programa: 0,
      total_etapas: payload.total_etapas || 5,
      _origem: "tce",
    };
  }

  if (programaEfetivo === 2) {
    return {
      ...payload,
      tipo_programa: 2,
      total_etapas: payload.total_etapas || 5,
      _origem: "tca-empregador",
    };
  }

  return payload;
}
